var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "62px",
    viewBox: "0 0 76 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C739D9BE-68DB-43B8-8F44-2F64DCCBD4C5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 4.77731459 0 4.77731459 4.8189 0 4.8189"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "1.42108547e-14 0 17.6249818 0 17.6249818 17.306207 1.42108547e-14 17.306207"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_Form-press",
    transform: "translate(-1645.000000, -1417.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(1645.000000, 1417.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.82037181,4.8686 C3.55237181,4.8686 3.28537181,4.7696 3.07737181,4.5696 L0.331371809,1.9396 C-0.0976281907,1.5296 -0.111628191,0.8486 0.298371809,0.4206 C0.708371809,-0.0084 1.38937181,-0.0224 1.81737181,0.3876 L4.56337181,3.0186 C4.99237181,3.4286 5.00637181,4.1086 4.59637181,4.5376 C4.38537181,4.7576 4.10337181,4.8686 3.82037181,4.8686",
    id: "Fill-1",
    fill: "#3669C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4312718,14.075 C13.1632718,14.075 12.8962718,13.976 12.6882718,13.776 L9.94227181,11.146 C9.51327181,10.736 9.49927181,10.055 9.90927181,9.627 C10.3192718,9.198 11.0002718,9.184 11.4282718,9.594 L14.1742718,12.225 C14.6032718,12.635 14.6172718,13.315 14.2072718,13.744 C13.9962718,13.964 13.7142718,14.075 13.4312718,14.075",
    id: "Fill-3",
    fill: "#3669C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33917181,14.1644 C1.06717181,14.1644 0.794171809,14.0614 0.585171809,13.8554 C0.162171809,13.4394 0.157171809,12.7594 0.573171809,12.3364 L3.20117181,9.6664 C3.61817181,9.2424 4.29817181,9.2374 4.72117181,9.6544 C5.14417181,10.0704 5.14917181,10.7504 4.73317181,11.1734 L2.10517181,13.8434 C1.89417181,14.0574 1.61717181,14.1644 1.33917181,14.1644",
    id: "Fill-5",
    fill: "#3669C9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(9.463315, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07465729,4.8189 C0.802657293,4.8189 0.529657293,4.7159 0.320657293,4.5099 C-0.102342707,4.0939 -0.107342707,3.4139 0.308657293,2.9909 L2.93765729,0.3209 C3.35365729,-0.1031 4.03365729,-0.1081 4.45665729,0.3089 C4.87965729,0.7249 4.88465729,1.4049 4.46865729,1.8279 L1.84065729,4.4979 C1.62965729,4.7119 1.35265729,4.8189 1.07465729,4.8189",
    id: "Fill-7",
    fill: "#3669C9",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(58.050882, 44.199793)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71418974,11.266307 C4.19318974,14.559307 8.13518974,16.056307 11.5021897,14.604307 C13.1451897,13.895307 14.4001897,12.602307 15.0381897,10.962307 C15.6611897,9.35830705 15.6161897,7.61030705 14.9111897,6.03930705 C13.4311897,2.74730705 9.48918974,1.24930705 6.12218974,2.70230705 C4.48018974,3.41030705 3.22418974,4.70430705 2.58718974,6.34430705 C1.96318974,7.94730705 2.00918974,9.69530705 2.71418974,11.266307 M8.82718974,17.306307 C5.44118974,17.306307 2.20518974,15.378307 0.754189745,12.146307 C-0.188810255,10.046307 -0.249810255,7.70930705 0.584189745,5.56530705 C1.43118974,3.38430705 3.09618974,1.66730705 5.27118974,0.729307049 C9.71118974,-1.18569295 14.9141897,0.801307049 16.8711897,5.15930705 C17.8141897,7.25930705 17.8741897,9.59630705 17.0411897,11.740307 C16.1931897,13.921307 14.5281897,15.638307 12.3531897,16.577307 C11.2061897,17.072307 10.0081897,17.306307 8.82718974,17.306307",
    id: "Fill-10",
    fill: "#3669C9",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.7476718,41.9126 C19.6176718,43.8486 21.9376718,44.7276 23.9196718,43.8726 C24.8846718,43.4556 25.6226718,42.6966 25.9966718,41.7346 C26.3616718,40.7956 26.3346718,39.7716 25.9216718,38.8526 C25.0526718,36.9166 22.7326718,36.0376 20.7506718,36.8926 C19.7846718,37.3096 19.0476718,38.0686 18.6726718,39.0306 C18.3086718,39.9696 18.3346718,40.9926 18.7476718,41.9126 M22.3466718,46.3466 C20.0156718,46.3466 17.7866718,45.0186 16.7876718,42.7926 C16.1366718,41.3436 16.0956718,39.7316 16.6706718,38.2516 C17.2546718,36.7496 18.4006718,35.5656 19.8986718,34.9196 C22.9546718,33.6026 26.5346718,34.9716 27.8816718,37.9716 C28.5326718,39.4206 28.5746718,41.0336 27.9996718,42.5126 C27.4156718,44.0156 26.2686718,45.1996 24.7706718,45.8456 C23.9826718,46.1856 23.1576718,46.3466 22.3466718,46.3466",
    id: "Fill-13",
    fill: "#3669C9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.0362b9cb9f3373f04ab53c88b8748548.svg";
export { ForwardRef as ReactComponent };